/**
 * MCP 落地页（/ai/chatgpt、/ai/claude、/ai/codex）共享的 i18next 取词器。
 * 用法：各页 constants.js 在 getConstants 内 `var i18next = require('../mcpLanding/i18nText').getI18next();`
 *       再用 i18next 的 t(key, default) 取词（key 形如 {pageId}-hero-title）。
 *       注意：本文件不要写出形如 i18next.t('真实key', ...) 的字面调用，否则会被翻译提取器误匹配并归到 /common。
 * 规则与 odm/constants.js 一致：
 * - SSR/CSR 一致：未初始化（或非浏览器）时回退到默认英文（fallback.t 直接返回第二个参数）。
 * - keySeparator/nsSeparator 用占位串，避免 key 里的 '.'/':' 被当成嵌套分隔。
 * 同时运行在 Node 与浏览器，使用 CommonJS。
 */
var fallback = {
  t: function (key, defaultValue) {
    return defaultValue;
  },
};

function getI18next() {
  if (
    typeof window !== 'undefined' &&
    window.i18next &&
    !window.i18next.isInitialized &&
    window.LNG
  ) {
    var lng = (document.cookie.match(/(?:^|;\s*)lng=([^;]*)/) || [])[1] || 'en';
    window.i18next.init({
      lng: lng,
      debug: false,
      resources: { [lng]: { translation: window.LNG } },
      keySeparator: '__keySeparator__',
      nsSeparator: '__nsSeparator__',
    });
  }
  return typeof window !== 'undefined' && window.i18next && window.i18next.isInitialized
    ? window.i18next
    : fallback;
}

module.exports = { getI18next: getI18next };
